
export class CurrencyInfo {
    constructor(public code: string, public sign: string) {
    }
}

export interface CurrencyContract {
    code: string;
    html: string;
}
